import React from "react";
import "./truck-progress-bar.css";
import truckIcon from "../../assets/png/truck.png";
export default function TruckProgressBar({ progress = 50 }) {
  // progress: 0 to 100
  return (
    <div className="truck-progress-container">
      <div className="truck-progress-track">
        <div
          className="truck-progress-fill"
          style={{ width: `${progress}%` }}
        />
        <div className="truck-progress-start"></div>
        <div className="truck-progress-end"></div>
        <img
          src={truckIcon} // truck image
          alt="truck"
          className="truck-icon"
          style={{ left: `calc(${progress}% - 16px)` }} // adjust for icon width
        />
      </div>
    </div>
  );
}
